import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect, Link } from "react-router-dom";

import {
  Tooltip,
  Button,
  Spinner,
  Badge,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Table } from "react-super-responsive-table";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/presensiService";

import IndexBloc from "../Blocs/IndexBlock";
import apiResponse from "../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";
import moment from "moment";

const formatDateWithTime = (value) => {
  if (value != "-") {
    let date = new Date(value);
    const day = date.toLocaleString("id-ID", { day: "2-digit" });
    const month = date.toLocaleString("id-ID", { month: "short" });
    const year = date.toLocaleString("id-ID", { year: "numeric" });
    const time = date.toLocaleTimeString("id-ID");

    return (
      day +
      " " +
      month +
      " " +
      year +
      " " +
      time.substring(0, 5).replace(/\./g, ":")
    );
  } else {
    return value;
  }
};

class TableTunkinComponent extends Component {
  indexBloc = new IndexBloc();
  userdata = JSON.parse(localStorage.getItem("userdata"));

  source;
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: false,
      submitVerification: null,
      rows: [],
      filteredRows: [],
      searchQuery: "",
      statusFilter: "",
      gradeFilter: "",
      is_verif: 0,
      pending_approval_cuti: 0,
      verification: null,
      runType: null,
      confirmInfo: "Apakah anda yakin akan melakukan verifikasi tunkin?",
      employee_nip: null,
      moreMenu: false,
      showValidationModal: false,
      missingGradeList: [],
      missingRankList: [],
      missingPositionList: [],
      activeAccordion: null,
    };
  }

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  getStatusText = (row) => {
    if (row && row.presensi_summary_status_penugasan) {
      const raw = String(row.presensi_summary_status_penugasan);
      const beforeBr = raw.split(/<br[\s/]*>|\n/i)[0];
      const s = beforeBr.replace(/<[^>]*>?/gm, "").trim();
      if (s && s !== "-") return s;
    }
    return "";
  };

  handleSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ searchQuery: value }, () => {
      this.filterRows();
    });
  };

  handleStatusChange = (e) => {
    const value = e.target.value;
    this.setState({ statusFilter: value }, () => {
      this.filterRows();
    });
  };

  handleGradeChange = (e) => {
    const value = e.target.value;
    this.setState({ gradeFilter: value }, () => {
      this.filterRows();
    });
  };

  filterRows = () => {
    const query = (this.state.searchQuery || "").trim().toLowerCase();
    const statusFilter = (this.state.statusFilter || "").trim();
    const gradeFilter = (this.state.gradeFilter || "").trim();

    const filtered = (this.state.rows || []).filter((row) => {
      if (query) {
        const nip = String(row.presensi_summary_employee_nip || "").toLowerCase();
        const name = String(row.employee_full_name || "").toLowerCase();
        if (!nip.includes(query) && !name.includes(query)) {
          return false;
        }
      }

      if (statusFilter) {
        const rowStatus = this.getStatusText(row);
        if (rowStatus !== statusFilter) {
          return false;
        }
      }

      if (gradeFilter) {
        const rawGrade = row.presensi_summary_emp_grade_akhir;
        const gradeStr = String(rawGrade ?? "").trim();
        const isZeroOrEmpty =
          rawGrade === null ||
          rawGrade === undefined ||
          gradeStr === "" ||
          gradeStr === "0" ||
          gradeStr === "-" ||
          gradeStr === "null" ||
          gradeStr === "undefined";

        if (gradeFilter === "0_or_empty") {
          if (!isZeroOrEmpty) return false;
        } else {
          if (gradeStr !== gradeFilter) return false;
        }
      }

      return true;
    });

    this.setState({ filteredRows: filtered });
  };

  loadData = async () => {
    this.setState({ loadingTable: true });
    var additionalFilter = this.props.additionalFilter;
    this.indexBloc.fetchListTunkin({ ...additionalFilter });
  };

  getListTunkin = async () => {
    this.setState({ loadingTable: true });
    var additionalFilter = this.props.additionalFilter;
    this.indexBloc.fetchListTunkin({ ...additionalFilter });
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
  };

  handleButtonExportTunkin = () => {
    this.indexBloc.fetchExportTunkin({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };

  handleButtonExportTunkinTxt = () => {
    this.indexBloc.fetchExportTunkinTxt({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };

  handleButtonGenerateTunkin() {
    this.indexBloc.setGenerate({
      tipe: 1,
      year: this.props.additionalFilter.year,
      month: this.props.additionalFilter.month,
      generate_verification_by_nip: this.userdata?.employee_nip,
      generate_verification_by_fullname: this.userdata?.employee_full_name,
    });
  }

  handleButtonExportPemadanan() {
    this.indexBloc.fetchExportMatching({
      year: this.props.additionalFilter.year,
      month: this.props.additionalFilter.month,
    });
  }

  handleButtonVerifikasiPemadanan() {
    this.indexBloc.fetchVerifikasiMatching({
      year: this.props.additionalFilter.year,
      month: this.props.additionalFilter.month,
      generate_verification_by_nip: this.userdata?.employee_nip,
      generate_verification_by_fullname: this.userdata?.employee_full_name,
    });
  }

  checkVerification() {
    this.indexBloc.fetchCheck({
      year: this.props.additionalFilter.year,
      month: this.props.additionalFilter.month,
      type: 1,
    });
  }

  getMissingData = () => {
    const missingGrade = [];
    const missingRank = [];
    const missingPosition = [];

    (this.state.rows || []).forEach((row) => {
      // 1. Check Grade (presensi_summary_emp_grade_akhir IS NULL / empty / 0 / -)
      const rawGrade = row.presensi_summary_emp_grade_akhir;
      const gradeStr = String(rawGrade ?? "").trim();
      if (
        rawGrade === null ||
        rawGrade === undefined ||
        gradeStr === "" ||
        gradeStr === "0" ||
        gradeStr === "-" ||
        gradeStr.toLowerCase() === "null" ||
        gradeStr.toLowerCase() === "undefined"
      ) {
        missingGrade.push(row);
      }

      // 2. Check Pangkat (employee_current_rank_group_room IS NULL / empty / -)
      const rawRank = row.employee_current_rank_group_room;
      const rankStr = String(rawRank ?? "").trim();
      const posStrInner = String(row.employee_current_position_name ?? "").trim();
      const catStrInner = String(row.presensi_summary_employee_categories_name_full ?? "").trim();

      const isStaffKhusus = catStrInner === 'INTERNAL » STAFF KHUSUS';
      const isMenteri = posStrInner === 'Menteri Investasi dan Hilirisasi/Kepala Badan Koordinasi Penanaman Modal';
      const isWamen = posStrInner === 'Wakil Menteri Investasi dan Hilirisasi/Wakil Kepala Badan Koordinasi Penanaman Modal';

      if (
        (rawRank === null ||
          rawRank === undefined ||
          rankStr === "" ||
          rankStr === "-" ||
          rankStr === "()" ||
          rankStr.toLowerCase() === "null" ||
          rankStr.toLowerCase() === "undefined") &&
        !isStaffKhusus &&
        !isMenteri &&
        !isWamen
      ) {
        missingRank.push(row);
      }

      // 3. Check Jabatan (employee_current_position_name IS NULL / empty / -)
      const rawPos = row.employee_current_position_name;
      const posStr = String(rawPos ?? "").trim();
      if (
        rawPos === null ||
        rawPos === undefined ||
        posStr === "" ||
        posStr === "-" ||
        posStr === "()" ||
        posStr.toLowerCase() === "null" ||
        posStr.toLowerCase() === "undefined"
      ) {
        missingPosition.push(row);
      }
    });

    return { missingGrade, missingRank, missingPosition };
  };

  handleVerifyTunkinClick = () => {
    const { missingGrade, missingRank, missingPosition } = this.getMissingData();


    if (
      missingGrade.length === 0 &&
      missingRank.length === 0 &&
      missingPosition.length === 0
    ) {
      this.setState({
        confirm: true,
        runType: 1,
        confirmInfo: "Apakah anda yakin akan melakukan verifikasi tunkin?",
      });
      return;
    }

    this.setState({
      showValidationModal: true,
      missingGradeList: missingGrade,
      missingRankList: missingRank,
      missingPositionList: missingPosition,
      activeAccordion: null,
    });
  };

  toggleValidationAccordion = (type) => {
    this.setState((prevState) => ({
      activeAccordion: prevState.activeAccordion === type ? null : type,
    }));
  };

  submitVerification = async () => {
    await this.indexBloc.fetchVerification({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
      description: this.userdata?.employee_full_name,
      type: 1,
    });
  };

  openVerification = async () => {
    await this.indexBloc.openVerification({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
      description: this.userdata?.employee_full_name,
      nip: this.userdata?.employee_nip,
      type: 1,
    });
  };

  syncData = async () => {
    let additionalFilter = this.props.additionalFilter;

    await this.indexBloc.fetchSync({
      employee_nip: this.state.employee_nip,
      type: 'tunkin',
      ...additionalFilter,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        if (this.state.runType == 1) {
          this.submitVerification();
        }

        if (this.state.runType == 2) {
          this.syncData();
        }

        if (this.state.runType == 5) {
          this.handleButtonGenerateTunkin();
        }
        if (this.state.runType == 6) {
          this.handleButtonExportPemadanan();
        }
        if (this.state.runType == 7) {
          this.handleButtonVerifikasiPemadanan();
        }
        if (this.state.runType == 10) {
          this.openVerification();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  fixMinioUrl = (brokenUrl) => {
    let once = decodeURIComponent(brokenUrl);
    const idx = once.indexOf("https://", 8);
    if (idx !== -1) {
      once = once.substring(idx);
    }

    const q1 = once.indexOf("?");
    const q2 = once.indexOf("?", q1 + 1);
    if (q1 !== -1 && q2 !== -1) {
      once = once.substring(0, q2);
    }

    return once;
  };

  componentDidMount() {
    this.indexBloc.listTunkinChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
            rows: [],
            filteredRows: [],
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          const rows = response.result || [];
          this.setState(
            {
              rows,
              loadingTable: false,
            },
            () => {
              this.filterRows();
            }
          );
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.setgenerateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
            rows: [],
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
            loadingTable: false,
          });
          this.props.handleCheckGenerateSuccess();
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.verificationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          this.props.handleCheckGenerateSuccess();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.openverificationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          this.props.handleCheckGenerateSuccess();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.syncChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          this.props.handleCheckGenerateSuccess();
          this.getListTunkin();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.exportTunkinChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          if (link?.file_url.url_encoded) {
            const fixedUrl = this.fixMinioUrl(link.file_url.url_encoded);
            window.open(fixedUrl, "_blank");
          } else {
            console.log("file_url", link.file_url);
            window.open(link.file_url, "_blank");
          }

          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          setTimeout(() => {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });

    this.indexBloc.exportTunkinTxtChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          setTimeout(() => {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.indexBloc.listTunkinChannel?.unsubscribe();
    this.indexBloc.setgenerateChannel?.unsubscribe();
    this.indexBloc.exportTunkinChannel?.unsubscribe();
    this.indexBloc.exportTunkinTxtChannel?.unsubscribe();
    this.indexBloc.exportMatchingChannel?.unsubscribe();
    this.indexBloc.verificationMatchingChannel?.unsubscribe();
  }

  render() {
    const uniqueStatuses = Array.from(
      new Set(
        (this.state.rows || [])
          .map((row) => this.getStatusText(row))
          .filter((s) => s !== "")
      )
    ).sort();

    const uniqueGrades = Array.from(
      new Set(
        (this.state.rows || [])
          .map((r) => String(r.presensi_summary_emp_grade_akhir ?? "").trim())
          .filter((g) => g !== "" && g !== "0" && g !== "-" && g !== "null" && g !== "undefined")
      )
    ).sort((a, b) => Number(a) - Number(b));

    const missingData = this.getMissingData();
    const hasMissingData = missingData.missingGrade.length > 0 || missingData.missingRank.length > 0 || missingData.missingPosition.length > 0;

    return (
      <>
        <div className="mb-4">
          {this.props.additionalFilter.verification_data_is_verif_tunkin === 0 ? (
            <div
              className="alert alert-danger d-flex align-items-center py-2 m-0 shadow-sm"
              style={{ fontSize: "0.85rem" }}
            >
              <i className="uil uil-info-circle fs-5 me-2"></i>
              <span>
                Status Verifikasi Tunjangan Kinerja Periode{" "}
                <strong>
                  {this.props.additionalFilter.month_name} {this.props.additionalFilter.year}
                </strong>{" "}
                : <strong>Belum Dilakukan Verifikasi</strong>
              </span>
            </div>
          ) : this.props.additionalFilter.verification_data_is_verif_tunkin === 1 ? (
            <div
              className="alert alert-success d-flex justify-content-between align-items-center py-2 m-0 shadow-sm"
              style={{ fontSize: "0.85rem" }}
            >
              <div>
                <i className="uil uil-check-circle fs-5 me-2"></i>
                <span>
                  Telah dilakukan Verifikasi Tunjangan Kinerja Periode{" "}
                  <strong>
                    {this.props.additionalFilter.month_name} {this.props.additionalFilter.year}
                  </strong>{" "}
                  oleh{" "}
                  <strong>
                    {this.props.additionalFilter.verification_data_description_tunkin}
                  </strong>{" "}
                  pada{" "}
                  {formatDateWithTime(
                    this.props.additionalFilter.verification_data_created_date_tunkin,
                  )}
                </span>
              </div>

              {hasMissingData && (
                <Button
                  color="link"
                  className="p-0 text-danger ms-3"
                  onClick={() => this.setState({
                    showValidationModal: true,
                    missingGradeList: missingData.missingGrade,
                    missingRankList: missingData.missingRank,
                    missingPositionList: missingData.missingPosition,
                    activeAccordion: null
                  })}
                  title="Peringatan Kelengkapan Data Pegawai"
                >
                  <i className="uil uil-exclamation-triangle fs-4"></i>
                </Button>
              )}
            </div>
          ) : null}
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <Button
              color="success"
              size="sm"
              className="me-2 shadow-sm"
              onClick={() => {
                this.setState({
                  confirm: true,
                  runType: 5,
                  confirmInfo: "Apakah anda yakin akan melakukan proses Generate Ulang?",
                });
              }}
              disabled={this.props.additionalFilter.is_generate_tunkin == 0}
            >
              <i className="uil-refresh me-1"></i>
              {this.props.additionalFilter.is_pay_tunkin == 1
                ? `Tunjangan Kinerja Periode ${this.props.additionalFilter.month_name} ${this.props.additionalFilter.year} telah dibayarkan`
                : this.props.additionalFilter.generate_verification_status_tunkin == 0
                  ? `Proses Generate Tunjangan Kinerja oleh: ${this.props.additionalFilter.generate_verification_by_fullname_tunkin}`
                  : this.props.additionalFilter.generate_verification_status_tunkin == 1
                    ? `Generate Ulang Tunjangan Kinerja (Last: ${this.props.additionalFilter.generate_verification_start_date_tunkin} s/d ${this.props.additionalFilter.generate_verification_end_date_tunkin} oleh ${this.props.additionalFilter.generate_verification_by_fullname_tunkin})`
                    : `Generate Ulang Tunjangan Kinerja Periode ${this.props.additionalFilter.month_name} ${this.props.additionalFilter.year}`}
            </Button>

            <Button
              color="danger"
              outline
              size="sm"
              className="shadow-sm"
              onClick={() =>
                this.setState({
                  confirm: true,
                  runType: 10,
                  confirmInfo:
                    "Apakah anda yakin akan membuka ulang hasil verifikasi Tunjangan Kinerja?",
                })
              }
              style={{
                display:
                  this.props.additionalFilter.verification_data_is_verif_tunkin == 1 &&
                    ["198501292014031001", "198903092012121002", "199508012025212056"].includes(this.userdata?.employee_nip)
                    ? "inline-block"
                    : "none",
              }}
            >
              <i className="uil uil-lock-open-alt me-1"></i> Buka Verifikasi
            </Button>
          </div>

          <div className="d-flex align-items-center">
            <Dropdown
              isOpen={this.state.moreMenu}
              toggle={() => {
                this.setState((prevState) => ({
                  moreMenu: !prevState.moreMenu,
                }));
              }}
              className="me-2 shadow-sm"
            >
              <DropdownToggle color="primary" outline size="sm" caret>
                Pemadanan Data
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    this.setState({
                      confirm: true,
                      runType: 6,
                      confirmInfo:
                        "Apakah anda yakin akan melakukan Export Data Pemadanan?",
                    });
                  }}
                >
                  Export Data
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    this.setState({
                      confirm: true,
                      runType: 7,
                      confirmInfo:
                        "Apakah anda yakin akan melakukan proses Verifikasi Kirim Ke Simkeu?",
                    });
                  }}
                >
                  Verifikasi kirim ke Simkeu
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>

            <Button
              color="warning"
              outline
              size="sm"
              className="me-2 shadow-sm border-warning text-dark"
              onClick={() => {
                this.handleButtonExportTunkin();
              }}
            >
              <i className="uil-file-download me-1"></i> Export Xls
            </Button>

            <Button
              color="primary"
              size="sm"
              className="shadow-sm fw-bold"
              onClick={() => this.handleVerifyTunkinClick()}
              disabled={
                this.props.additionalFilter.verification_data_is_verif_tunkin ==
                1
              }
            >
              <i className="uil uil-check-circle me-1"></i> Verifikasi Tunjangan Kinerja
            </Button>
          </div>
        </div>

        <div className="d-flex flex-wrap gap-2 mb-3 align-items-center">
          <div className="input-group me-2" style={{ maxWidth: "340px" }}>
            <span className="input-group-text">
              <i className="uil uil-search"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Pencarian Berdasarkan NIP dan Nama"
              value={this.state.searchQuery || ""}
              onChange={this.handleSearchChange}
            />
          </div>

          <div className="me-2" style={{ minWidth: "180px" }}>
            <select
              className="form-select form-control"
              value={this.state.statusFilter || ""}
              onChange={this.handleStatusChange}
            >
              <option value="">Semua Status TK</option>
              {uniqueStatuses.map((s, idx) => (
                <option key={idx} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>

          <div style={{ minWidth: "180px" }}>
            <select
              className="form-select form-control"
              value={this.state.gradeFilter || ""}
              onChange={this.handleGradeChange}
            >
              <option value="">Semua Grade</option>
              <option value="0_or_empty">Grade 0 / Kosong</option>
              {uniqueGrades.map((g, idx) => (
                <option key={idx} value={g}>
                  Grade {g}
                </option>
              ))}
            </select>
          </div>
        </div>

        <style>{`
          .sticky-header-table thead th {
            box-shadow: inset -1px 0 0 #c8cce1, inset 0 -1px 0 #b9bfd3 !important;
          }
        `}</style>
        <div
          className="table-responsive"
          style={{ maxHeight: "75vh", overflowX: "auto", overflowY: "auto" }}
        >
          <Table
            className="table table-striped table-bordered sticky-header-table"
            style={{
              minWidth: "1400px",
              borderCollapse: "collapse",
              border: "1px solid #c8cce1",
            }}
          >
            <thead
              className="table-primary"
              style={{
                position: "sticky",
                top: 0,
                zIndex: 3,
                backgroundColor: "#f8f9fa",
              }}
            >
              <tr>
                <th
                  className="text-center align-middle"
                  style={{
                    width: "50px",
                    minWidth: "50px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                    boxShadow: "inset -1px 0 0 #c8cce1, inset 0 -1px 0 #b9bfd3",
                    position: "sticky",
                    left: 0,
                    zIndex: 4,
                  }}
                  rowSpan="2"
                >
                  No
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    width: "250px",
                    minWidth: "250px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                    boxShadow: "inset -1px 0 0 #c8cce1, inset 0 -1px 0 #b9bfd3",
                    position: "sticky",
                    left: "50px",
                    zIndex: 4,
                  }}
                  rowSpan="2"
                >
                  NIP <br />
                  Nama
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    fontWeight: 600,
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  colSpan="6"
                >
                  Bulan Sebelumnya
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    fontWeight: 600,
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  colSpan="12"
                >
                  Sekarang
                </th>
              </tr>
              <tr>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff9dc",
                    border: "1px solid #c8cce1",
                    borderTop: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  Grade
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff9dc",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  PLT/PLH
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff9dc",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  Hukuman Disiplin
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff9dc",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  Total Potongan
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff9dc",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  Status TK
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff9dc",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  Keterangan
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderTop: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  Grade
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  PLT/PLH
                </th>
                <th
                  className="text-center align-top table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  %<br></br>Tidak Masuk
                </th>
                <th
                  className="text-center align-top table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  %<br></br>Terlambat
                </th>
                <th
                  className="text-center align-top table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  %<br></br>Pulang Awal
                </th>
                <th
                  className="text-center align-top table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  %<br></br>Single Finger
                </th>
                <th
                  className="text-center align-top table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  %<br></br>SKP
                </th>
                <th
                  className="text-center align-top table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  %<br></br>Hukuman Disiplin
                </th>
                <th
                  className="text-center align-top table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  %<br></br>Total Potongan
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  Status TK
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                  }}
                  width="*"
                >
                  Keterangan
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingTable == false ? (
                (this.state.filteredRows || []).length > 0 ? (
                  (this.state.filteredRows || []).map((data, index) => {
                    return (
                      <tr id={"tr_tunkin_" + index} key={index}>
                        <td
                          className="text-center"
                          style={{
                            borderColor: "#c8cce1",
                            boxShadow: "inset -1px 0 0 #c8cce1",
                            position: "sticky",
                            left: 0,
                            backgroundColor: "#ffffff",
                            zIndex: 2,
                          }}
                        >
                          {index + 1}
                        </td>
                        <td style={{
                          borderColor: "#c8cce1",
                          boxShadow: "inset -1px 0 0 #c8cce1",
                          position: "sticky",
                          left: "50px",
                          backgroundColor: "#ffffff",
                          zIndex: 2,
                        }}
                        >
                          <b>{data.presensi_summary_employee_nip}</b> <br />
                          {data.employee_full_name} <br />
                          <br />
                          <small>
                            {data.presensi_summary_employee_categories_name_full}
                          </small>
                          <br /> <br />
                          <Button
                            outline
                            color="primary"
                            className="btn-sm"
                            onClick={() =>
                              this.setState({
                                confirm: true,
                                runType: 2,
                                employee_nip: data.presensi_summary_employee_nip,
                                confirmInfo:
                                  "Apakah anda yakin akan melakukan kalkulasi ulang untuk data " +
                                  data.employee_full_name +
                                  " ?",
                              })
                            }
                          >
                            <i className="uil-refresh"></i> Kalkulasi Ulang
                          </Button>
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{
                            backgroundColor: "rgb(255, 250, 233)",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_old_emp_grade}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{
                            backgroundColor: "rgb(255, 250, 233)",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_tunkin_old_plt_plh}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{
                            backgroundColor: "rgb(255, 250, 233)",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_tunkin_old_punishment}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{
                            backgroundColor: "rgb(255, 250, 233)",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_tunkin_old_total}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{
                            backgroundColor: "rgb(255, 250, 233)",
                            borderColor: "#c8cce1",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: data.presensi_summary_status_penugasan_old,
                          }}
                        />
                        <td
                          className="text-center table-warning"
                          style={{
                            backgroundColor: "rgb(255, 250, 233)",
                            borderColor: "#c8cce1",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: data.presensi_summary_keterangan_old,
                          }}
                        />
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_emp_grade_akhir}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_is_show_text == 1
                            ? "-"
                            : data.presensi_summary_tunkin_plt_plh}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_is_show_text == 1
                            ? "-"
                            : data.presensi_summary_presentase_tunkin_tidak_masuk}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_is_show_text == 1
                            ? "-"
                            : data.presensi_summary_presentase_tunkin_telat_masuk}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_is_show_text == 1
                            ? "-"
                            : data.presensi_summary_presentase_tunkin_pulang_cepat}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_is_show_text == 1
                            ? "-"
                            : data.presensi_summary_presentase_tunkin_single_finger}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_is_show_text == 1
                            ? "-"
                            : data.presensi_summary_skp_kinerja}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_is_show_text == 1
                            ? "-"
                            : data.presensi_summary_presentase_punishment_discipline}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                        >
                          {data.presensi_summary_tunkin_total}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: data.presensi_summary_status_penugasan,
                          }}
                        />
                        <td
                          className="text-center table-success"
                          style={{
                            backgroundColor: "#e6ffe5",
                            borderColor: "#c8cce1",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: data.presensi_summary_keterangan,
                          }}
                        />
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="20" className="text-center">
                      Tidak Ada Data
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td colSpan="20" className="text-center">
                    <Spinner className="m-2" color="primary" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <ConfirmAlert
            confirmTitle="Konfirmasi!"
            confirmInfo={this.state.confirmInfo}
            loadingTitle="Mengambil data"
            loadingInfo="Tunggu beberapa saat"
            successTitle="Berhasil!"
            successInfo="Data berhasil diproses"
            failedTitle="Gagal!"
            failedInfo="Data gagal diproses"
            showConfirm={this.state.confirm}
            showLoading={this.state.loading}
            showSuccess={this.state.success}
            showFailed={this.state.failed}
            response={this.confirmResponse}
          />

          <Modal
            isOpen={this.state.showValidationModal}
            toggle={() => this.setState({ showValidationModal: false })}
            size="lg"
            centered
          >
            <ModalHeader
              toggle={() => this.setState({ showValidationModal: false })}
              className="bg-soft-danger text-danger"
            >
              <i className="uil uil-exclamation-triangle me-2"></i>
              Peringatan Kelengkapan Data Pegawai
            </ModalHeader>
            <ModalBody>
              <p className="text-muted mb-3">
                Terdapat data pegawai yang belum lengkap pada periode ini. Klik pada daftar di bawah untuk melihat rincian pegawai:
              </p>

              {this.state.missingGradeList.length > 0 && (
                <div className="border rounded mb-3 shadow-sm">
                  <div
                    className="d-flex justify-content-between align-items-center p-3 bg-light rounded cursor-pointer"
                    style={{ cursor: "pointer" }}
                    onClick={() => this.toggleValidationAccordion("grade")}
                  >
                    <span className="fw-bold text-danger">
                      <i className="uil uil-exclamation-circle me-2"></i>
                      Terdapat Grade ({this.state.missingGradeList.length} Pegawai) Tidak Mempunyai Grade
                    </span>
                    <i
                      className={`uil uil-angle-${this.state.activeAccordion === "grade" ? "up" : "down"
                        } fs-5`}
                    ></i>
                  </div>
                  {this.state.activeAccordion === "grade" && (
                    <div
                      className="p-3 border-top bg-white"
                      style={{ maxHeight: "250px", overflowY: "auto" }}
                    >
                      <div className="text-muted small mb-2">
                        Tidak Mempunyai Grade
                      </div>
                      {this.state.missingGradeList.map((emp, idx) => (
                        <div
                          key={idx}
                          className="py-1 border-bottom border-light d-flex align-items-center"
                        >
                          <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                            {emp.presensi_summary_employee_nip}
                          </span>
                          <span className="fw-bold me-2">-</span>
                          <span>
                            {emp.employee_full_name}
                            {(this.getStatusText(emp) || emp.presensi_summary_employee_categories_name_full) && (
                              <span className="ms-1 text-muted">
                                ({[this.getStatusText(emp), emp.presensi_summary_employee_categories_name_full].filter(Boolean).join(' - ')})
                              </span>
                            )}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {this.state.missingRankList.length > 0 && (
                <div className="border rounded mb-3 shadow-sm">
                  <div
                    className="d-flex justify-content-between align-items-center p-3 bg-light rounded cursor-pointer"
                    style={{ cursor: "pointer" }}
                    onClick={() => this.toggleValidationAccordion("rank")}
                  >
                    <span className="fw-bold text-danger">
                      <i className="uil uil-exclamation-circle me-2"></i>
                      Terdapat Pangkat ({this.state.missingRankList.length} Pegawai) Tidak Mempunyai Pangkat
                    </span>
                    <i
                      className={`uil uil-angle-${this.state.activeAccordion === "rank" ? "up" : "down"
                        } fs-5`}
                    ></i>
                  </div>
                  {this.state.activeAccordion === "rank" && (
                    <div
                      className="p-3 border-top bg-white"
                      style={{ maxHeight: "250px", overflowY: "auto" }}
                    >
                      <div className="text-muted small mb-2">
                        Tidak Mempunyai Pangkat
                      </div>
                      {this.state.missingRankList.map((emp, idx) => (
                        <div
                          key={idx}
                          className="py-1 border-bottom border-light d-flex align-items-center"
                        >
                          <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                            {emp.presensi_summary_employee_nip}
                          </span>
                          <span className="fw-bold me-2">-</span>
                          <span>
                            {emp.employee_full_name}
                            {(this.getStatusText(emp) || emp.presensi_summary_employee_categories_name_full) && (
                              <span className="ms-1 text-muted">
                                ({[this.getStatusText(emp), emp.presensi_summary_employee_categories_name_full].filter(Boolean).join(' - ')})
                              </span>
                            )}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {this.state.missingPositionList.length > 0 && (
                <div className="border rounded mb-3 shadow-sm">
                  <div
                    className="d-flex justify-content-between align-items-center p-3 bg-light rounded cursor-pointer"
                    style={{ cursor: "pointer" }}
                    onClick={() => this.toggleValidationAccordion("position")}
                  >
                    <span className="fw-bold text-danger">
                      <i className="uil uil-exclamation-circle me-2"></i>
                      Terdapat Jabatan ({this.state.missingPositionList.length} Pegawai) Tidak Mempunyai Jabatan
                    </span>
                    <i
                      className={`uil uil-angle-${this.state.activeAccordion === "position" ? "up" : "down"
                        } fs-5`}
                    ></i>
                  </div>
                  {this.state.activeAccordion === "position" && (
                    <div
                      className="p-3 border-top bg-white"
                      style={{ maxHeight: "250px", overflowY: "auto" }}
                    >
                      <div className="text-muted small mb-2">
                        Tidak Mempunyai Jabatan
                      </div>
                      {this.state.missingPositionList.map((emp, idx) => (
                        <div
                          key={idx}
                          className="py-1 border-bottom border-light d-flex align-items-center"
                        >
                          <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                            {emp.presensi_summary_employee_nip}
                          </span>
                          <span className="fw-bold me-2">-</span>
                          <span>
                            {emp.employee_full_name}
                            {(this.getStatusText(emp) || emp.presensi_summary_employee_categories_name_full) && (
                              <span className="ms-1 text-muted">
                                ({[this.getStatusText(emp), emp.presensi_summary_employee_categories_name_full].filter(Boolean).join(' - ')})
                              </span>
                            )}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              <div className="alert alert-warning mt-3 mb-0 small">
                <i className="uil uil-info-circle me-1"></i>
                Segera Lakukan Pengecekan dan Perbaikan Data Tersebut!.
              </div>
            </ModalBody>

            {this.props.additionalFilter.verification_data_is_verif_tunkin !== 1 && (
              <ModalFooter className="d-flex justify-content-between">
                <Button
                  color="secondary"
                  onClick={() => this.setState({ showValidationModal: false })}
                >
                  <i className="uil uil-times me-1"></i> Batal / Perbaiki Data
                </Button>
                <Button
                  color="primary"
                  onClick={() => {
                    this.setState({
                      showValidationModal: false,
                      confirm: true,
                      runType: 1,
                      confirmInfo:
                        "Apakah anda yakin akan melakukan verifikasi tunkin?",
                    });
                  }}
                >
                  <i className="uil uil-check-circle me-1"></i> Tetap Lanjutkan Proses
                </Button>
              </ModalFooter>
            )}
          </Modal>
        </div>
      </>
    );
  }
}

export default TableTunkinComponent;
